import { useRouterState } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';

import { trackPageView } from '@/lib/analytics';
import { startAppwriteAutoTracking } from '@/lib/appwrite-analytics';

/**
 * Tracks public page / article views on client-side navigations.
 * Mount once under the root document (outside admin-only layouts is fine;
 * admin paths are skipped inside trackPageView).
 */
export function AnalyticsTracker() {
    const pathname = useRouterState({ select: (s) => s.location.pathname });
    const search = useRouterState({ select: (s) => s.location.searchStr });
    const lastKey = useRef<string | null>(null);

    useEffect(() => startAppwriteAutoTracking(), []);

    useEffect(() => {
        const key = `${pathname}${search}`;
        if (lastKey.current === key) return;
        lastKey.current = key;
        trackPageView(pathname, search);
    }, [pathname, search]);

    return null;
}
